"use strict";
/**
 * imports
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
// external
const inversify_1 = require("inversify");
/**
 * event emitter class
 */
let EventEmitter = class EventEmitter {
    /**
     * constructor
     */
    constructor() {
        // all event listeners
        this.listeners = {};
        this.listeners = {};
    }
    /**
     * turn on an event for an event handler
     *
     * @param {string} eventName
     * @param {eventHandler} handler
     */
    on(eventName, handler) {
        // if listener for event doesn't exist, initialise it
        if (typeof this.listeners[eventName] === "undefined") {
            this.listeners[eventName] = [];
        }
        // don't add if this event + handler is already registered
        if (this.listeners[eventName].indexOf(handler) !== -1) {
            console.warn("Did not register event handler, handler already registered");
            return;
        }
        // add handler to event listener
        this.listeners[eventName].push(handler);
    }
    /**
     * turn off an event for an event handler
     *
     * @param {string} eventName
     * @param {eventHandler} handler
     */
    off(eventName, handler) {
        // remove handler for event from listeners
        if (typeof this.listeners[eventName] !== "undefined") {
            this.listeners[eventName] = this.listeners[eventName].filter(x => x !== handler);
        }
    }
    /**
     * emit and event with given arguments
     *
     * @param {string} eventName
     * @param args
     */
    emit(eventName, ...args) {
        // make sure event listener exists
        if (typeof this.listeners[eventName] !== "undefined") {
            // for each handler run it with the given arguments
            this.listeners[eventName].forEach(handler => {
                handler.apply(null, args);
            });
        }
    }
    /**
     * get the number of listeners
     * for testing purposes
     *
     * @param {string} eventName
     * @returns {number}
     */
    numListeners(eventName) {
        // return number of listeners for given event
        if (eventName !== undefined) {
            const listenersArr = this.listeners[eventName] || [];
            return listenersArr.length;
        }
        // return number of all listeners
        const numListeners = Object.keys(this.listeners).reduce((acc, val) => {
            return acc + this.listeners[val].length;
        }, 0);
        return numListeners;
    }
};
EventEmitter = __decorate([
    (0, inversify_1.injectable)()
], EventEmitter);
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map